import axios from "axios";
import { config } from "@/config/constants";

export default (method, url, params, allData = false) => {
  return new Promise((resolve, reject) => {
    const apiData = {
      method,
      url: `${config.api_url}${url}`,
      config: {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      },
      ...(method === "delete" || method === "get"
        ? { params }
        : { data: params })
    };

    axios(apiData)
      .then(response => {
        resolve(allData ? response : response.data);
      })
      .catch(error => {
        const customError = {
          status: error.response.status,
          message: error.response.data
        };
        reject(customError);
      });
  });
};
